/**
 * @generated SignedSource<<2ae56860386389c88e23798866858f56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type editRootExtensionForm_RootExtensionImplFragment$data = {
  readonly abbreviation: string | null;
  readonly certificationProduct: {
    readonly id: string;
    readonly title: string;
  } | null;
  readonly courseContentProduct: {
    readonly id: string;
    readonly title: string;
  } | null;
  readonly diploma: string | null;
  readonly learnGoalsOpt: string | null;
  readonly product: {
    readonly id: string;
    readonly title: string;
  } | null;
  readonly tags: ReadonlyArray<{
    readonly data: {
      readonly name: string;
    };
    readonly id: string;
  }>;
  readonly trailerOpt: string | null;
  readonly " $fragmentType": "editRootExtensionForm_RootExtensionImplFragment";
};
export type editRootExtensionForm_RootExtensionImplFragment$key = {
  readonly " $data"?: editRootExtensionForm_RootExtensionImplFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"editRootExtensionForm_RootExtensionImplFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "editRootExtensionForm_RootExtensionImplFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "learnGoalsOpt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trailerOpt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AcademiesTagData",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diploma",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "abbreviation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "courseContentProduct",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "certificationProduct",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "RootExtensionImpl",
  "abstractKey": null
};
})();

(node as any).hash = "b8244754cb77c1f1f946ad1d77234898";

export default node;
